'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _UndefinedContent = require('./UndefinedContent');

var _UndefinedContent2 = _interopRequireDefault(_UndefinedContent);

var _files = require('../lib/files');

var _browser = require('../lib/browser');

var _formElementsTypes = require('../constants/formElementsTypes');

var _PictureModal = require('./PictureModal');

var _PictureModal2 = _interopRequireDefault(_PictureModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getSummaryData = function getSummaryData(data, downloadOnClick, extraData, toggleImageModal) {
  return data.map(function (item, i) {
    return _react2.default.createElement(
      'div',
      { key: i, className: _classnames2.default.apply(undefined, ['item'].concat(_toConsumableArray(item.customClassNames || []), [{ hidden: item.hidden }])) },
      item.label && _react2.default.createElement(
        'span',
        { className: 'ui horizontal label' },
        item.label
      ),
      !item.value && _react2.default.createElement(_UndefinedContent2.default, null),
      !Array.isArray(item.value) && item.value,
      Array.isArray(item.value) && item.value.length > 0 && _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('summaryItemsList', (item.type || 'text') + 'SummaryItemsList') },
        item.value.map(function (valueItem, j) {
          return _react2.default.createElement(
            'div',
            { key: j, className: 'summaryItemsListItem' },
            item.type === _formElementsTypes.FILES_URLS && (0, _files.isImage)(valueItem) && _react2.default.createElement(
              'a',
              {
                href: valueItem,
                onClick: function onClick(event) {
                  if (!downloadOnClick) {
                    (0, _browser.stopPropagation)(event);
                    toggleImageModal(valueItem, true);
                  }
                }
              },
              _react2.default.createElement('div', {
                className: 'filePreview imagePreview',
                style: {
                  backgroundImage: 'url("' + valueItem + '")',
                  backgroundSize: ((extraData[i] || {})[j] || {}).backgroundSize || 'auto 100%'
                }
              })
            ),
            item.type === _formElementsTypes.FILES_URLS && (0, _files.isImage)(valueItem) && extraData[i] && (extraData[i][j] || {}).shouldShowModal && _react2.default.createElement(_PictureModal2.default, {
              shouldShowModal: true,
              onModalHide: function onModalHide() {
                return toggleImageModal(valueItem, false);
              },
              file: valueItem
            }),
            item.type === _formElementsTypes.FILES_URLS && !(0, _files.isImage)(valueItem) && _react2.default.createElement(
              'a',
              { className: 'filePreview', href: valueItem },
              _react2.default.createElement(
                'div',
                null,
                (0, _files.getFilename)(valueItem)
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('i', { className: (0, _classnames2.default)('file', (0, _files.getExtension)(valueItem), 'outline', 'icon') })
              )
            ),
            item.type !== _formElementsTypes.FILES_URLS && valueItem
          );
        })
      ),
      Array.isArray(item.value) && item.value.length === 0 && _react2.default.createElement(_UndefinedContent2.default, null)
    );
  });
};

var FormSummary = function (_Component) {
  _inherits(FormSummary, _Component);

  function FormSummary(props) {
    _classCallCheck(this, FormSummary);

    var _this = _possibleConstructorReturn(this, (FormSummary.__proto__ || Object.getPrototypeOf(FormSummary)).call(this, props));

    _this.state = {
      extraData: []
    };
    return _this;
  }

  _createClass(FormSummary, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.tryInit(this.props.data);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.tryInit(nextProps.data);
    }
  }, {
    key: 'toggleImageModal',
    value: function toggleImageModal(url, shouldShowModal) {
      var data = this.props.data;


      var imageIndex = data[0].value.indexOf(url);

      // Let's put the generated backgroundSizes in the first element of extraData
      var extraData = [].concat(_toConsumableArray(this.state.extraData))[0] || [];

      extraData = _lodash2.default.range(data[0].value.length).map(function (i) {
        return _extends({}, extraData[i] || {}, {
          shouldShowModal: shouldShowModal && i === imageIndex
        });
      });

      this.setState({ extraData: [extraData] });
    }
  }, {
    key: 'tryInit',
    value: function tryInit(data) {
      var _this2 = this;

      // In this function, since we are looking for file urls, we will assume
      // that in that case data contains only one element.
      if (!data || (data[0] || {}).type !== _formElementsTypes.FILES_URLS) {
        return;
      }

      var pGetBackgroundSize = _bluebird2.default.promisify(_files.getBackgroundSize);

      _bluebird2.default.map(data[0].value, function (fileUrl) {
        return pGetBackgroundSize(fileUrl);
      }).then(function (backgroundSizes) {

        // Let's put the generated backgroundSizes in the first element of extraData
        var extraData = [].concat(_toConsumableArray(_this2.state.extraData))[0] || [];

        extraData = _lodash2.default.range(data[0].value.length).map(function (i) {
          return _extends({}, extraData[i] || {}, {
            backgroundSize: backgroundSizes[i]
          });
        });

        _this2.setState({ extraData: [extraData] });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          downloadOnClick = _props.downloadOnClick,
          action = _props.action,
          canEditForm = _props.canEditForm,
          editButtonLabel = _props.editButtonLabel;


      if (!data) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('infoList', { editable: canEditForm }) },
        _react2.default.createElement(
          'div',
          { className: 'ui divided list' },
          getSummaryData(data, downloadOnClick, this.state.extraData, this.toggleImageModal.bind(this))
        ),
        canEditForm && _react2.default.createElement(
          'button',
          { onClick: action, className: 'ui labeled icon button right floated' },
          _react2.default.createElement('i', { className: 'edit icon' }),
          ' ',
          editButtonLabel
        )
      );
    }
  }]);

  return FormSummary;
}(_react.Component);

;

FormSummary.propTypes = {
  data: _propTypes2.default.array.isRequired,
  action: _propTypes2.default.func.isRequired,
  canEditForm: _propTypes2.default.bool,
  editButtonLabel: _propTypes2.default.string,
  downloadOnClick: _propTypes2.default.bool
};

FormSummary.defaultProps = {
  canEditForm: true
};

exports.default = FormSummary;


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/components/FormSummary.js
// module id = 291
// module chunks = 0